import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/Navbar.css'

class Navbar extends React.Component {
  constructor(props){
    super(props);
  }
  render () {
    return(
      <div className="Navbar">
        <h1>{this.props.name}</h1>
      </div>
    )
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js